module.exports = __webpack_public_path__ + "img/Satellite-View.e244b02c.png";